import React, { useEffect, useState } from "react";

// Material-UI
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@material-ui/lab";

// Styles
import useStyles from "./styles/AlamatDialog";

import { useSnackbar } from "notistack";
import {
  firefunctions,
  firestore,
  GeoPoint,
} from "../../../components/firebase/FirebaseProvider";
import { useData } from "../../../components/firebase/DataProvider";
import Gap from "../../../components/atoms/Gap";
import {
  Checkbox,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Typography,
} from "@material-ui/core";
import Maps from "../../../components/molecules/Maps";

import ArrowBackIcon from "@material-ui/icons/ArrowBack";

function AlamatDialog({ open, handleClose, action, data }) {
  const { profil, alamat_pusat, menu_alamat } = useData();
  // console.log(data);
  const [currentPos, setCurrentPos] = useState(null);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const position = {
    lat: alamat_pusat?.koordinat?.latitude,
    lng: alamat_pusat?.koordinat?.longitude,
  };

  const [form, setForm] = useState({
    judul: "",
    judulLainnya: "",
    nama_penerima: "",
    no_telepon: "",
    provinsi: {},
    kota: {},
    kecamatan: {},
    kelurahan: {},
    alamat_lengkap: "",
    destination_direction: "",
  });

  const [error, setError] = useState({
    judul: "",
    nama_penerima: "",
    no_telepon: "",
    provinsi: "",
    kota: "",
    kecamatan: "",
    kelurahan: "",
    alamat_lengkap: "",
  });

  const classes = useStyles();
  const [loadingProvinsi, setLoadingProvinsi] = useState(false);
  const [provinsi, setProvinsi] = useState([]);
  useEffect(() => {
    async function fetchProvinsi() {
      setLoadingProvinsi(true);
      try {
        const getProvinsi = firefunctions.httpsCallable("getProvinsi");

        const response = await getProvinsi();

        setProvinsi(response.data);
      } catch (e) {
        console.log(e.message);
      }
      setLoadingProvinsi(false);
    }

    fetchProvinsi();
  }, []);

  const [loadingKota, setLoadingKota] = useState(false);
  const [kota, setKota] = useState([]);
  useEffect(() => {
    async function fetchKota() {
      setLoadingKota(true);
      try {
        const getKota = firefunctions.httpsCallable("getKota");

        if (form.provinsi.id) {
          const response = await getKota({ provinsi_id: form.provinsi?.id });

          setKota(response.data);
        }
      } catch (e) {
        console.log(e.message);
      }
      setLoadingKota(false);
    }

    fetchKota();
  }, [form.provinsi.id]);

  const [loadingKecamatan, setLoadingKecamatan] = useState(false);
  const [kecamatan, setKecamatan] = useState([]);
  useEffect(() => {
    async function fetchKecamatan() {
      setLoadingKecamatan(true);
      try {
        const getKecamatan = firefunctions.httpsCallable("getKecamatan");

        if (form.kota.id) {
          const response = await getKecamatan({
            kota_id: form?.kota?.id,
            provinsi_id: form.provinsi?.id,
          });

          setKecamatan(response.data);
        }
      } catch (e) {
        console.log(e.message);
      }
      setLoadingKecamatan(false);
    }

    fetchKecamatan();
  }, [form.kota.id]);

  const [loadingKelurahan, setLoadingKelurahan] = useState(false);
  const [kelurahan, setKelurahan] = useState([]);
  useEffect(() => {
    async function fetchKelurahan() {
      setLoadingKelurahan(true);
      try {
        const getKelurahan = firefunctions.httpsCallable("getKelurahan");

        if (form.kecamatan.id) {
          const response = await getKelurahan({
            kota_id: form?.kota?.id,
            provinsi_id: form.provinsi?.id,
            kecamatan_id: form?.kecamatan?.id,
          });

          setKelurahan(response.data);
        }
      } catch (e) {
        console.log(e.message);
      }
      setLoadingKelurahan(false);
    }

    fetchKelurahan();
  }, [form.kecamatan.id]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setError((error) => ({
      ...error,
      [name]: "",
    }));

    switch (name) {
      case "provinsi":
        setForm((form) => ({
          ...form,
          [name]: value,
          kota: {},
          kecamatan: {},
          kelurahan: {},
        }));
        setKota([]);
        setKecamatan([]);
        setKelurahan([]);
        break;
      case "kota":
        setForm((form) => ({
          ...form,
          [name]: value,
          kecamatan: {},
          kelurahan: {},
        }));
        setKecamatan([]);
        setKelurahan([]);
        break;
      case "kecamatan":
        setForm((form) => ({
          ...form,
          [name]: value,
          kelurahan: {},
        }));
        setKelurahan([]);
        break;
      case "kelurahan":
        setForm((form) => ({
          ...form,
          [name]: value,
        }));
        break;
      default:
        setForm((form) => ({
          ...form,
          [name]: value.replace(/'|"/g, ""),
        }));

        break;
    }
  };

  const validate = () => {
    const newError = { ...error };
    // const req = /^[a-z0-9.,\s]+$/i;

    const {
      judul,
      nama_penerima,
      no_telepon,
      provinsi,
      kota,
      kecamatan,
      kelurahan,
      alamat_lengkap,
    } = form;

    if (!judul) {
      newError.judul = "Judul wajib diisi";
    }

    if (!nama_penerima) {
      newError.nama_penerima = "Nama penerima wajib diisi";
    }

    if (!no_telepon) {
      newError.no_telepon = "Nomor telepon wajib diisi";
    } else if (!Number(no_telepon)) {
      newError.no_telepon = "Nomor telepon tidak valid";
    }

    if (!provinsi.name) {
      newError.provinsi = "Provinsi wajib diisi";
    }

    if (!kota.name) {
      newError.kota = "Kota wajib diisi";
    }

    if (!kecamatan.name) {
      newError.kecamatan = "Kecamatan wajib diisi";
    }

    if (!kelurahan.name) {
      newError.kelurahan = "Kelurahan wajib diisi";
    }

    if (!alamat_lengkap) {
      newError.alamat_lengkap = "Detail alamat wajib diisi";
    }
    //  else if (!req.test(form.alamat_lengkap)) {
    //   newError.alamat_lengkap =
    //     "Alamat hanya boleh terdiri dari huruf dan angka .(titik), dan ,(koma)";
    // }

    return newError;
  };

  const [checked, setChecked] = useState(false);
  const [titik_maps, setTitik_maps] = useState(false);

  const togglecheckbox = (e) => {
    setChecked(e.target.checked);
  };

  const togglecheckboxTitikAlamat = (e) => {
    setTitik_maps(e.target.checked);
  };

  const handleDelete = async () => {
    if (window.confirm(`Apakah Anda Ingin Menghapus Alamat Ini?`)) {
      setIsSubmitting(true);
      try {
        // history.push("/alamat");
        await firestore.doc(`users/${profil.id}/alamat/${data.id}`).delete();
        enqueueSnackbar("Alamat Berhasil Dihapus", {
          variant: "success",
        });
      } catch (error) {
        console.log(error.message);
      }
      setIsSubmitting(false);
      handleClose();
    }
  };

  const handleSimpan = async () => {
    const findErrors = validate();
    const { judulLainnya, ...formRest } = form;

    if (Object.values(findErrors).some((err) => err !== "")) {
      setError(findErrors);
    } else {
      try {
        setIsSubmitting(true);

        const ref = firestore
          .collection("users")
          .doc(profil.id)
          .collection("alamat");

        if (action === "edit") {
          const doc = {
            ...formRest,
            judul: form.judul === "lainnya" ? form.judulLainnya : form.judul,
            koordinat: titik_maps
              ? new GeoPoint(currentPos?.lat, currentPos?.lng)
              : "",
            updated_at: Date.now(),
          };
          await ref.doc(data.id).set(doc, { merge: true });
          if (checked) {
            const usersCol = firestore.collection(`users`);
            await usersCol
              .doc(profil.id)
              .set({ alamat_utama: data.id }, { merge: true });
          }
        } else {
          const data = {
            ...formRest,
            judul: form.judul === "lainnya" ? form.judulLainnya : form.judul,
            koordinat: titik_maps
              ? new GeoPoint(currentPos?.lat, currentPos?.lng)
              : "",
            created_at: Date.now(),
            updated_at: Date.now(),
          };
          const newAlamat = await ref.add(data);
          // console.log(newAlamat);
          if (checked) {
            const usersCol = firestore.collection(`users`);
            await usersCol
              .doc(profil.id)
              .set({ alamat_utama: newAlamat.id }, { merge: true });
          }
        }

        setIsSubmitting(false);
        enqueueSnackbar("Alamat Berhasil Diperbarui", {
          variant: "success",
        });
        handleClose();
      } catch (err) {
        setIsSubmitting(false);
        console.log(err.message);
        enqueueSnackbar("Alamat Gagal Diperbarui", {
          variant: "error",
        });
        handleClose();
      }
      setIsSubmitting(false);
    }
  };
  useEffect(() => {
    if (action === "edit" && data) {
      const judulAlm = menu_alamat?.judul.filter((v) => v === data.judul);
      setForm({
        // ...form,
        ...data,
        judul: judulAlm[0] === data.judul ? data.judul : "lainnya",

        judulLainnya: judulAlm[0] !== data.judul ? data.judul : "",
      });
      if (data?.koordinat) {
        setCurrentPos({
          lat: data?.koordinat?.latitude,
          lng: data?.koordinat?.longitude,
        });
        setTitik_maps(true);
      } else {
        setTitik_maps(false);
      }
      if (data.id === profil.alamat_utama || !profil.alamat_utama) {
        setChecked(true);
      } else {
        setChecked(false);
      }
    }
  }, [action, data]);

  const title = action === "edit" ? "Ubah Alamat" : "Tambah Alamat";

  const handleClick = () => {
    setForm({
      judul: "",
      nama_penerima: "",
      no_telepon: "",
      provinsi: {},
      kota: {},
      kecamatan: {},
      kelurahan: {},
      alamat_lengkap: "",
    });
    setError({
      judul: "",
      nama_penerima: "",
      no_telepon: "",
      provinsi: "",
      kota: "",
      kecamatan: "",
      kelurahan: "",
      alamat_lengkap: "",
    });
    setCurrentPos(null);
    handleClose();
  };
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(function (position) {
      setCurrentPos({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      });
    });
  }, []);

  const menuAlamat = [...menu_alamat?.judul, "lainnya"];
  return (
    <Dialog
      open={open}
      onClose={handleClick}
      fullScreen
      PaperProps={{
        style: { maxWidth: 960 },
      }}
    >
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconButton
            size="small"
            onClick={handleClick}
            style={{ marginRight: 15 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography>{title}</Typography>
        </div>
      </DialogTitle>
      <DialogContent dividers style={{ padding: 10 }}>
        <Gap height={10} />
        <Autocomplete
          id="judul"
          name="judul"
          required
          disableClearable
          value={form.judul}
          onChange={(event, value) => {
            handleChange({ target: { name: "judul", value } });
          }}
          disabled={isSubmitting}
          options={menuAlamat}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Judul"
              fullWidth
              InputLabelProps={{ shrink: true }}
              helperText={error?.judul}
              error={error?.judul ? true : false}
              variant="outlined"
            />
          )}
        />
        <Gap height={15} />
        {form.judul === "lainnya" ? (
          <>
            <TextField
              name="judulLainnya"
              label="Judul Lainnya"
              fullWidth
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              value={form.judulLainnya}
              helperText={error.judul}
              error={error.judul ? true : false}
              disabled={isSubmitting}
              autoComplete="off"
            />
            <Gap height={15} />{" "}
          </>
        ) : null}
        <Gap height={15} />
        <div style={{ marginLeft: "5px" }}>
          <Typography variant="caption">
            * Jika nama dan no. HP pengirim tidak terisi, Keterangan pengirim
            otomatis akan disesuaikan dengan data yang ada pada Tokorame mu
          </Typography>
        </div>
        <Gap height={15} />
        <TextField
          name="nama_pengirim"
          label="Nama Pengirim"
          fullWidth
          inputProps={{
            maxLength: "20",
          }}
          placeholder="Contoh: Bu Suci"
          onChange={handleChange}
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={form.nama_penerima}
          helperText={error.nama_penerima}
          error={error.nama_penerima ? true : false}
          disabled={isSubmitting}
          autoComplete="off"
        />
        <Gap height={15} />
        <TextField
          name="no_telepon_pengirim"
          label="Nomor Telepon Pengirim"
          fullWidth
          placeholder="Nomor Telepon Pengirim"
          onChange={handleChange}
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={form.no_telepon_pengirim}
          helperText={error.no_telepon_pengirim}
          error={error.no_telepon_pengirim ? true : false}
          disabled={isSubmitting}
          autoComplete="off"
          type="tel"
        />
        <Gap height={15} />
        <TextField
          name="nama_penerima"
          label="Nama Penerima"
          fullWidth
          inputProps={{
            maxLength: "20",
          }}
          placeholder="Contoh: Bu Suci"
          onChange={handleChange}
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={form.nama_penerima}
          helperText={error.nama_penerima}
          error={error.nama_penerima ? true : false}
          disabled={isSubmitting}
          autoComplete="off"
        />
        <Gap height={15} />
        <TextField
          name="no_telepon"
          label="Nomor Telepon"
          fullWidth
          placeholder="Nomor Telepon Penerima"
          onChange={handleChange}
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={form.no_telepon}
          helperText={error.no_telepon}
          error={error.no_telepon ? true : false}
          disabled={isSubmitting}
          autoComplete="off"
          type="tel"
        />
        <Gap height={15} />
        <Autocomplete
          id="provinsi"
          name="provinsi"
          required
          disableClearable
          value={form.provinsi}
          onChange={(event, value) => {
            handleChange({ target: { name: "provinsi", value } });
          }}
          disabled={isSubmitting}
          options={provinsi}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              // margin="dense"
              {...params}
              label="Provinsi"
              InputLabelProps={{ shrink: true }}
              helperText={error?.provinsi}
              error={error?.provinsi ? true : false}
              variant="outlined"
            />
          )}
        />
        <Gap height={15} />
        <Autocomplete
          id="kota"
          name="kota"
          required
          disableClearable
          value={form.kota}
          onChange={(event, value) => {
            handleChange({ target: { name: "kota", value } });
          }}
          disabled={isSubmitting}
          options={kota}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              // margin="dense"
              {...params}
              label="Kota"
              InputLabelProps={{ shrink: true }}
              helperText={error?.kota}
              error={error?.kota ? true : false}
              variant="outlined"
            />
          )}
        />
        <Gap height={15} />
        <Autocomplete
          id="kecamatan"
          name="kecamatan"
          required
          disableClearable
          value={form.kecamatan}
          onChange={(event, value) => {
            handleChange({ target: { name: "kecamatan", value } });
          }}
          disabled={isSubmitting}
          options={kecamatan}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Kecamatan"
              InputLabelProps={{ shrink: true }}
              helperText={error?.kecamatan}
              error={error?.kecamatan ? true : false}
              variant="outlined"
            />
          )}
        />
        <Gap height={15} />
        <Autocomplete
          id="kelurahan"
          name="kelurahan"
          required
          disableClearable
          value={form.kelurahan}
          onChange={(event, value) => {
            handleChange({ target: { name: "kelurahan", value } });
          }}
          disabled={isSubmitting}
          options={kelurahan}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Kelurahan"
              InputLabelProps={{ shrink: true }}
              helperText={error?.kelurahan}
              error={error?.kelurahan ? true : false}
              variant="outlined"
            />
          )}
        />
        <Gap height={15} />
        <TextField
          name="alamat_lengkap"
          label="Detail Alamat"
          fullWidth
          inputProps={{
            maxLength: "85",
          }}
          onChange={handleChange}
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={form.alamat_lengkap}
          helperText={error.alamat_lengkap}
          error={error.alamat_lengkap ? true : false}
          disabled={isSubmitting}
          autoComplete="off"
        />
        <Gap height={15} />
        <FormControlLabel
          control={
            <Checkbox
              disabled={isSubmitting}
              onChange={togglecheckboxTitikAlamat}
              checked={titik_maps}
              name="titik_maps"
              color="default"
            />
          }
          label="Pilih Titik Maps (Opsional)"
        />
        <Gap height={15} />
        {titik_maps ? (
          <>
            <Maps
              center={position}
              currentPos={currentPos}
              setCurrentPos={setCurrentPos}
            />
            <Gap height={15} />
          </>
        ) : (
          ""
        )}

        <TextField
          name="destination_direction"
          label="Patokan (opsional)"
          fullWidth
          onChange={handleChange}
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={form.destination_direction}
          disabled={isSubmitting}
          autoComplete="off"
        />
        <Gap height={15} />
        <FormControlLabel
          control={
            <Checkbox
              disabled={
                isSubmitting ||
                profil.alamat_utama === data?.id ||
                !profil.alamat_utama
              }
              onChange={togglecheckbox}
              checked={checked}
              name="alamat_utama"
              color="default"
            />
          }
          label="Jadikan Alamat Utama"
        />
        <Gap height={15} />

        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleSimpan}
          disabled={isSubmitting}
          style={{ marginBottom: "10px" }}
        >
          Simpan
        </Button>
        {action === "edit" ? (
          <Button
            style={{ marginBottom: "10px" }}
            fullWidth
            variant="outlined"
            color="primary"
            onClick={handleDelete}
            disabled={isSubmitting || profil.alamat_utama === data?.id}
          >
            Hapus
          </Button>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}

export default AlamatDialog;
